import { render } from "./AcceptLN.vue?vue&type=template&id=3b56804c"
import script from "./AcceptLN.vue?vue&type=script&lang=js"
export * from "./AcceptLN.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../../DEV/_vue3/reactive-clinic/rc-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__